<script>
import { mapGetters } from 'vuex';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
export default {
  components: {
    MultiselectDropdown,
  },
  props: {
    showAccountModal: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['closeAccountModal', 'showCreateAccountModal'],
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
    }),
    selectedAccount() {
      if (!this.currentUser || !this.currentUser.accounts) {
        return null;
      }
      return this.currentUser.accounts.find(
        account => account.id === this.accountId
      );
    },
    filteredAccounts() {
      if (!this.currentUser || !this.currentUser.accounts) {
        return [];
      }
      if (!this.searchQuery) {
        return this.currentUser.accounts;
      }
      // Filtra a lista de contas pelo nome, ignorando maiúsculas/minúsculas
      return this.currentUser.accounts.filter(account =>
        account.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    onChangeAccount(accountId) {
      const accountUrl = `/app/accounts/${accountId}/dashboard`;
      window.location.href = accountUrl;
    },
    onAccountSelect(selectedAccount) {
      if (selectedAccount && selectedAccount.id) {
        this.onChangeAccount(selectedAccount.id);
      }
    },
    onQuerySearch(query) {
      this.searchQuery = query;
    },
  },
};
</script>

<template>
  <div
    v-if="showAccountModal"
    class="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
    @click="() => $emit('closeAccountModal')"
    
  >
    <div
      class="modal-container bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[80vh] overflow-y-auto overflow-hidden"
      @click.stop
    >
      <div
        class="modal-header p-6 border-b border-gray-200 flex justify-between items-center"
      >
        <h2 class="text-xl font-bold text-gray-800">
          {{ $t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS') }}
        </h2>
        <button
          class="p-2 rounded-full hover:bg-red-100 transition-colors"
          @click="() => $emit('closeAccountModal')"
        >
          <svg
            class="w-6 h-6 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body p-6 flex flex-col gap-6">
        <div class="flex flex-col gap-2">
          <span class="text-sm font-medium text-gray-700">
            {{ $t('SIDEBAR_ITEMS.SELECTOR_SUBTITLE') }}

          </span>
          <MultiselectDropdown
          :options="filteredAccounts"
          :selected-item="selectedAccount"
          :multiselector-placeholder="$t('SIDEBAR_ITEMS.SELECT_ACCOUNT')"
          :no-search-result="$t('SIDEBAR_ITEMS.NO_ACCOUNTS_FOUND')"
          :input-placeholder="$t('SIDEBAR_ITEMS.SEARCH_ACCOUNTS')"
          :query-search="true"
          @select="onAccountSelect"
          @query-search="onQuerySearch"
        />
        </div>
      </div>
      <div
        class="modal-footer p-6 border-t border-gray-200 flex justify-end gap-4"
      >
        <woot-button
          @click="$emit('showCreateAccountModal')"
        >
          {{ $t('CREATE_ACCOUNT.NEW_ACCOUNT') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-container {
  position: relative;
  overflow: visible;
}

.modal-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
}

.modal-body {
  overflow: visible;
}

.modal-footer {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 1;
}
</style>
